"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["componentType", "barClassName", "barItemClassName", "className", "formName", "datas", "mode", "params", "position", "tabs", "type", "wrapper", "wrapperFunc"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var index_1 = require("../../../index");

var replaceTestParams_1 = __importDefault(require("../../../utils/replaceTestParams"));

var verifyCondition_1 = __importDefault(require("../../../utils/verifyCondition"));

var index_2 = __importDefault(require("../index"));

var Bar_1 = __importDefault(require("./Bar"));

var TitleSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var TabsSC = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  div.grid + & {\n    margin-top: ", ";\n  }\n"])), function (props) {
  return props && props.theme && props.theme.spacing && props.theme.defaultSpace ? props.theme.spacing[props.theme.defaultSpace] : '0';
});

var DataTabs = function DataTabs(_ref) {
  var componentType = _ref.componentType,
      barClassName = _ref.barClassName,
      barItemClassName = _ref.barItemClassName,
      className = _ref.className,
      formName = _ref.formName,
      datas = _ref.datas,
      mode = _ref.mode,
      params = _ref.params,
      position = _ref.position,
      tabs = _ref.tabs,
      type = _ref.type,
      wrapper = _ref.wrapper,
      wrapperFunc = _ref.wrapperFunc,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useState)({}),
      _ref3 = _slicedToArray(_ref2, 2),
      searchParams = _ref3[0],
      setSearchParams = _ref3[1];

  var _ref4 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref4.sc;

  var _ref5 = (0, react_1.useState)(0),
      _ref6 = _slicedToArray(_ref5, 2),
      tab = _ref6[0],
      setTab = _ref6[1];

  var _ref7 = (0, react_1.useState)([]),
      _ref8 = _slicedToArray(_ref7, 2),
      infos = _ref8[0],
      setInfos = _ref8[1];

  var newDatas = (0, react_1.useMemo)(function () {
    return datas && !Array.isArray(datas) ? [datas] : datas;
  }, [datas]);
  var formValues = (0, react_redux_1.useSelector)(function (state) {
    return state.form && formName && state.form[formName] ? state.form[formName].values : {};
  });
  (0, react_1.useEffect)(function () {
    var newTab = 0;

    if (typeof window !== 'undefined' && window.location && window.location.search) {
      var search = {};
      window.location.search.slice(1).split('&').forEach(function (option) {
        var _option$split = option.split('='),
            _option$split2 = _slicedToArray(_option$split, 2),
            key = _option$split2[0],
            value = _option$split2[1];

        search[key] = value;
      });

      if (search.tab) {
        newTab = parseInt(search.tab, 10);
      }

      setSearchParams(search);
    }

    setTab(newTab);
  }, []);
  (0, react_1.useEffect)(function () {
    if (newDatas) {
      var newInfos = [];
      newDatas.forEach(function (newData, i) {
        var _a;

        var addNewTab = true;

        if ('string' !== typeof tabs[i]) {
          var tmpTab = tabs[i]; // On vérifie si il y a une condition

          if (tmpTab === null || tmpTab === void 0 ? void 0 : tmpTab.condition) {
            var newTest = params ? (0, replaceTestParams_1.default)(tmpTab.condition, params) : tmpTab.condition;
            addNewTab = (0, verifyCondition_1.default)({
              formValues: formValues,
              test: newTest
            });
          }
        }

        if (addNewTab) {
          newInfos.push({
            index: i,
            isActive: tab === i,
            title: 'string' === typeof tabs[i] ? tabs[i] : (_a = tabs[i]) === null || _a === void 0 ? void 0 : _a.name
          });
        }
      });
      setInfos(newInfos);
    }
  }, [formValues, newDatas, params, tab, tabs]);

  var handleButtonOnClick = function handleButtonOnClick(event) {
    var newTab = event.currentTarget.getAttribute('data-tab');

    if (newTab) {
      setTab(parseInt(newTab, 10));
      var location = window && window.location ? window.location.pathname : '/';

      var search = _objectSpread(_objectSpread({}, searchParams), {}, {
        tab: newTab
      });

      location += "?".concat(Object.keys(search).map(function (key) {
        return "".concat(key, "=").concat(search[key]);
      }).join('&'));
      window.history.replaceState({
        location: location,
        tab: newTab
      }, "tab ".concat(newTab), location);
    }
  };

  if ('collapse' === type) {
    return react_1.default.createElement("div", null, infos.map(function (info) {
      return react_1.default.createElement(react_1.default.Fragment, {
        key: info.index
      }, react_1.default.createElement(TitleSC, {
        as: sc && sc.groupTitle
      }, info.title), newDatas && newDatas.length > info.index && react_1.default.createElement(index_2.default, _objectSpread(_objectSpread({}, newDatas[info.index]), {}, {
        formName: formName,
        mode: mode,
        params: params,
        position: "".concat(position ? "".concat(position, ".") : '', "datas[").concat(info.index, "]"),
        wrapper: wrapper,
        wrapperFunc: wrapperFunc
      })));
    }));
  }

  return react_1.default.createElement(TabsSC, _objectSpread(_objectSpread({
    as: sc && sc.tabs
  }, props), {}, {
    className: className
  }), react_1.default.createElement(Bar_1.default, {
    className: barClassName,
    handleButtonOnClick: handleButtonOnClick,
    infos: infos,
    itemClassName: barItemClassName
  }), newDatas && newDatas.length > tab && react_1.default.createElement(index_2.default, _objectSpread(_objectSpread({}, newDatas[tab]), {}, {
    formName: formName,
    mode: mode,
    params: params,
    position: "".concat(position ? "".concat(position, ".") : '', "datas[").concat(tab, "]"),
    wrapper: wrapper,
    wrapperFunc: wrapperFunc
  })));
};

exports.default = DataTabs;